import { PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'react';

import { login, logout, signup } from '../../../services/database';

import { loginAction, logoutAction } from './auth.slice';
import { LoginDTO, SignupDTO, User } from './auth.types';

/**
 * registers a new user's account
 */
export const dispatchSignup =
  (dto: SignupDTO) =>
  async (dispatch: Dispatch<PayloadAction<User>>): Promise<User> => {
    const user: User = await signup(dto);
    dispatch(loginAction(user));
    return user;
  };

/**
 * login to a user's account
 */
export const dispatchLogin =
  (dto: LoginDTO) =>
  async (dispatch: Dispatch<PayloadAction<User>>): Promise<User> => {
    const user: User = await login(dto);
    dispatch(loginAction(user));
    return user;
  };

/**
 * login to a user's account
 */
export const dispatchLogout =
  () =>
  async (dispatch: Dispatch<PayloadAction<void>>): Promise<void> => {
    await logout();
    dispatch(logoutAction());
  };
